/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { defineMessages } from 'react-intl';

import { formatErrorResponse } from 'responseFormatterFunctions';
import { I18NError } from 'Utils';
import { fetchGet, fetchDelete, fetchPost } from 'FetchAPIs';

const baseHierarchiesURL = '/api/hierarchies';

const messages = defineMessages({
  errorFetchingKPIs: 'Error fetching functions. {message}',
  errorCreatingKPIs: 'Error creating functions. {message}',
  errorDeletingKPIs: 'Error deleting functions. {message}',
});

export function getV2KPIs(resourceUUID, dataItemUUID, userEmailId) {
  return fetchGet(
    `${baseHierarchiesURL}/workspaces/resources/${resourceUUID}/dataItems/${dataItemUUID}/kpiFunctions`,
    {
      userEmailId,
    }
  ).catch(error => {
    throw new I18NError(messages.errorFetchingKPIs, {
      message: formatErrorResponse(error),
    });
  });
}

export function addV2KPIs(resourceUUID, kpiFunctionsToAdd, dataItemUUID, userEmailId) {
  return fetchPost(
    `${baseHierarchiesURL}/workspaces/resources/${resourceUUID}/dataItems/${dataItemUUID}/kpiFunctions`,
    kpiFunctionsToAdd,
    {
      userEmailId,
    }
  ).catch(error => {
    throw new I18NError(messages.errorCreatingKPIs, {
      message: formatErrorResponse(error),
    });
  });
}

export function removeV2KPIs(resourceUUID, kpiFunctionsToDelete, dataItemUUID, userEmailId) {
  return fetchDelete(
    `${baseHierarchiesURL}/workspaces/resources/${resourceUUID}/dataItems/${dataItemUUID}/kpiFunctions`,
    null,
    {
      userEmailId,
    },
    { kpiFunctionNames: kpiFunctionsToDelete.join(', ') }
  )
    .then(res => res)
    .catch(error => {
      throw new I18NError(messages.errorDeletingKPIs, {
        message: formatErrorResponse(error),
      });
    });
}
